export default __webpack_public_path__ + "static/media/Levitate D7.2 Short term impacts of CCAM on freight transport.dbb5b39e.pdf";